export default {"src":"/_next/static/media/logo-1.61cb030d.svg","height":101,"width":228,"blurWidth":0,"blurHeight":0};